import { render, staticRenderFns } from "./company-type-modal.vue?vue&type=template&id=6a43b071&"
import script from "./company-type-modal.vue?vue&type=script&lang=js&"
export * from "./company-type-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports